import styled from 'styled-components';
import { Layout, LayoutProps } from 'antd';
import { theme } from 'consts/theme';

interface StyledContentProps extends LayoutProps {
  $isOnline?: boolean;
}

const defaultShadow = '1px 0px 3px -2px rgba(0, 0, 0, 0.1), -1px 0px 3px -2px rgba(0, 0, 0, 0.1)';
const offlineShadow = 'inset 0px 0px 8px 0px rgba(247, 55, 55, 0.57)';

export const StyledContent = styled(Layout.Content)<StyledContentProps>`
  background-color: ${theme.colors.white};
  box-shadow: ${({ $isOnline }) => ($isOnline ? defaultShadow : offlineShadow)};
  display: flex;
  justify-content: safe center;
  justify-items: stretch;
  align-items: stretch;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: wrap;

  // Experimental way of showing bottom shadows to indicate scrooling
  background: /* Shadow covers */
    linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */ radial-gradient(farthest-side at 50% 0, rgba(17, 17, 17, 0), rgba(0, 0, 0, 0)),
    radial-gradient(farthest-side at 50% 130%, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0)) 0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size:
    100% 20px,
    100% 40px,
    100% 14px,
    100% 14px;
  /* Opera doesn't support this in the shorthand */
  background-attachment: local, local, local, scroll;
`;
